'use client';

import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useWebSession } from '@/context/WebSessionContext';
import { identifyPerson, setGroup } from '@/util/posthog/identify';

/**
 * Keeps client observability context aligned with the signed-in Attik user.
 */
export default function AttikObservabilityScope() {
  const { data: session, status } = useWebSession();

  // Keep PostHog person and company context aligned with the active web session.
  useEffect(() => {
    if (status !== 'authenticated' || !session?.user) {
      if (status === 'unauthenticated') posthog.reset();
      posthog.register({ surface: 'web' });
      return;
    }
    const u = session.user as typeof session.user & {
      id?: string;
      _id?: string;
      firstName?: string | null;
      lastName?: string | null;
      company?: { _id?: string | null } | null;
      _companyId?: string | null;
    };
    const userId = u.id ?? u._id;
    if (!userId) {
      posthog.register({ surface: 'web' });
      return;
    }
    const userIdStr = String(userId);
    const companyId = u.company?._id ?? u._companyId;
    const companyIdStr = companyId ? String(companyId) : '';
    identifyPerson(userIdStr, {
      name: [u.firstName, u.lastName].filter(Boolean).join(' ') || undefined,
    });
    posthog.register({
      surface: 'web',
      attik_user_id: userIdStr,
      ...(companyIdStr ? { company_id: companyIdStr } : {}),
    });
    if (companyIdStr) setGroup('company', companyIdStr);
  }, [session, status]);

  return null;
}
